up.$compiler('[trigger-content-reload]', ($element) => {
  up.reload('.content--main', { layer: 'page' })
});
